<template>
  <div>
    <div class="w-full full-login">
      <div class="block sm:flex justify-center align-items-center">
        <form @submit.prevent="sendEmail" class="xl:h-auto flex justify-center">
          <div
            class="my-10 mb-4 mx-4 px-4 py-8 bg-white rounded-md sm:w-9/12 w-full"
            style="box-shadow: 0px 4px 50px 0px #00000026"
          >
            <img
              v-if="urlOriginIsBrandIn"
              alt="COTIZADOR"
              class="-intro-x -mt-16"
              style="display: block; margin: auto; width: 200px"
              :src="require(`@/assets/images/COT-img/logo-brand-in.png`)"
            />
            <img
              v-else
              alt="COTIZADOR"
              class="-intro-x -mt-16"
              style="display: block; margin: auto; width: 200px"
              :src="require(`@/assets/images/COT-img/logo.png`)"
            />
            <div class="intro-x mt-8 px-8">
              <div class="intro-x text-theme-2 text-center text-base">
                Ingresa tus correo de Brand In para empezar el proceso de
                activación
              </div>
            </div>
            <div class="intro-x mt-2 px-8">
              <div class="intro-x text-theme-2 text-left">Correo</div>
              <input
                id="validation-form-2"
                v-model.trim="email"
                type="email"
                name="email"
                required
                class="intro-x login__input form-control py-3 px-4 border-theme-3 block mb-2"
                :class="{ 'border-theme-6': v$.email.$error }"
                placeholder="example@gmail.com"
              />
              <template v-if="v$.email.$errors">
                <div
                  v-for="(error, index) in v$.email.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo correo es requerido</strong
                  >
                  <strong v-else-if="error.$validator === 'email'"
                    >El campo correo debe ser un email válido</strong
                  >
                </div>
              </template>
            </div>
            <div class="intro-x mt-5 xl:mt-8 text-center px-8">
              <button
                type="submit"
                :disabled="v$.$invalid"
                class="btn btn-quotation-login text-base py-3 px-4 w-60 border-0"
              >
                Siguiente
              </button>
            </div>

            <hr
              style="border-bottom: 1px solid rgba(196, 196, 196, 1)"
              class="mt-10 mx-auto w-4/5"
            />
            <div
              class="intro-x mt-5 text-theme-4 text-center text-base mx-8 pb-4"
            >
              <router-link :to="{ name: 'login' }" tag="a" class="text-lg">
                Ya tengo mi cuenta activa
              </router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.full-login {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: center;
}
</style>

<script>
import useVuelidate from '@vuelidate/core'
import { email, required } from '@vuelidate/validators'
import { getFirstErrorMessage } from '@/utils/tools'

export default {
  data() {
    return {
      email: ''
    }
  },
  setup() {
    return { v$: useVuelidate() }
  },
  beforeMount() {
    cash('html').addClass('unauthenticated')
  },
  validations() {
    return {
      email: { required, email, $autoDirty: true }
    }
  },
  validationConfig: {
    $lazy: false
  },
  methods: {
    async sendEmail() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post('otp/send-otp-email-to-activate-user', {
          email: this.email
        })
        this.$router.push(`/otp/${this.email}`)
      } catch (error) {
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    }
  },
  computed: {
    urlOriginIsBrandIn() {
      const currentHost = (window.location?.host || '').replace(/^www\./, '')
      const brandInDomain = (process.env.VUE_APP_BRAND_IN_DOMAIN || '').replace(
        /^www\./,
        ''
      )
      return currentHost === brandInDomain
    }
  }
}
</script>
